import { render, staticRenderFns } from "./InviteHistory.vue?vue&type=template&id=6935a867&"
import script from "./InviteHistory.vue?vue&type=script&lang=js&"
export * from "./InviteHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports